export default class Entity<T>{
    id:T
}


// WEBPACK FOOTER //
// ./src/store/entities/entity.ts